import Immutable from "immutable";

import {
  FETCH_INSIGHT_LIST,
  FETCH_INSIGHT_LIST_ERROR,
  USER_SIGNED_OUT,
} from "../constants/action-types";

const insight = Immutable.Record({
  id: undefined,
  title: undefined,
  summary: undefined,
  recommendation: undefined,
  risk_level: undefined,
  data_start_utc_epoch: undefined,
  data_end_utc_epoch: undefined,
  company_id: undefined,
  sites: undefined,
  has_download: undefined,
});

// @ts-expect-error legacy opshub typing
export const data = new Immutable.Set([]);

export const InsightState = Immutable.Record(
  {
    fetchError: false,
    fetchErrorMessage: "",
    fetchErrorStatus: "",
    data: data,
    loadingState: "loading",
  },
  "InsightState"
);

export default (state = new InsightState(), action) => {
  // @ts-expect-error legacy opshub typing
  let newData = new Immutable.Set([]);
  switch (action.type) {
    case FETCH_INSIGHT_LIST:
      action.payload.forEach(function (insightItem) {
        newData = newData.add(new insight(insightItem));
      });

      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.data = newData;
        // @ts-expect-error legacy opshub typing
        s.fetchError = false;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = "";
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = "";
        // @ts-expect-error legacy opshub typing
        s.loadingState = "loaded";
      });

    case FETCH_INSIGHT_LIST_ERROR:
      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.fetchError = true;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = action.payload.message;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = action.payload.status;
        // @ts-expect-error legacy opshub typing
        s.loadingState = "error";
      });

    case USER_SIGNED_OUT:
      return state.withMutations((s) => {
        // @ts-expect-error legacy opshub typing
        s.data = new Immutable.Set([]);
        // @ts-expect-error legacy opshub typing
        s.fetchError = false;
        // @ts-expect-error legacy opshub typing
        s.fetchErrorMessage = "";
        // @ts-expect-error legacy opshub typing
        s.fetchErrorStatus = "";
        // @ts-expect-error legacy opshub typing
        s.loadingState = "loaded";
      });

    default:
      return state;
  }
};
